// @flow

const locationImageUrl = user => {
    if (!user.location) {
        return `https://maps.googleapis.com/maps/api/staticmap?center=0,0&zoom=8&size=300x300&format=png&key=${
            process.env.REACT_APP_GOOGLE_MAPS_API_KEY
        }`;
    }

    return `https://maps.googleapis.com/maps/api/staticmap?center=${90 - user.location.ypos},${user
        .location.xpos - 180}&zoom=8&size=300x300&format=png&key=${
        process.env.REACT_APP_GOOGLE_MAPS_API_KEY
    }`;
};

export { locationImageUrl };



// WEBPACK FOOTER //
// ./src/utils/map.js